import { AbstractControl } from '@angular/forms';
/* tslint:disable */
export const REGEX = new RegExp(/^((https?:\/\/)?([\w-]+(\.[\w-]+)+|localhost)\.?(:\d+)?((\/)?\S*)?)$/i);

// Validation to ensure the text entered is of type url
export function urlValidator(control: AbstractControl): { [key: string]: any } {
  return !control.value ? null : REGEX.test(control.value) ? null : { url: '' };
}
